/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AggregatedUptimeResponse
 */
export interface AggregatedUptimeResponse {
    /**
     * The aggregated uptime. Offline periods are not considered in the availability calculation. i.e., devices assumed to be continuously online.
     * @type {number}
     * @memberof AggregatedUptimeResponse
     */
    uptimeOfflineIncluded?: number;
    /**
     * The aggregated uptime. Offline periods are removed from the availability calculation.
     * @type {number}
     * @memberof AggregatedUptimeResponse
     */
    uptimeOfflineExcluded?: number;
    /**
     * The preferred uptime value based on organisation preference. Defaults to UptimeOfflineIncluded if preference not set.
     * @type {number}
     * @memberof AggregatedUptimeResponse
     */
    preferredUptime?: number;
    /**
     * Indicates which calculation method was used for PreferredUptime. true = offline included, false = offline excluded.
     * @type {boolean}
     * @memberof AggregatedUptimeResponse
     */
    isOfflineIncluded?: boolean;
    /**
     * Percentage change compared to the previous period of the same duration. Positive values indicate improvement.
     * @type {number}
     * @memberof AggregatedUptimeResponse
     */
    percentageChange?: number;
    /**
     * Calculation period start.
     * @type {Date}
     * @memberof AggregatedUptimeResponse
     */
    periodStart?: Date;
    /**
     * Calculation period end.
     * @type {Date}
     * @memberof AggregatedUptimeResponse
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the AggregatedUptimeResponse interface.
 */
export function instanceOfAggregatedUptimeResponse(
    value: object,
): value is AggregatedUptimeResponse {
    return true;
}

export function AggregatedUptimeResponseFromJSON(
    json: any,
): AggregatedUptimeResponse {
    return AggregatedUptimeResponseFromJSONTyped(json, false);
}

export function AggregatedUptimeResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AggregatedUptimeResponse {
    if (json == null) {
        return json;
    }
    return {
        uptimeOfflineIncluded:
            json["uptimeOfflineIncluded"] == null
                ? undefined
                : json["uptimeOfflineIncluded"],
        uptimeOfflineExcluded:
            json["uptimeOfflineExcluded"] == null
                ? undefined
                : json["uptimeOfflineExcluded"],
        preferredUptime:
            json["preferredUptime"] == null
                ? undefined
                : json["preferredUptime"],
        isOfflineIncluded:
            json["isOfflineIncluded"] == null
                ? undefined
                : json["isOfflineIncluded"],
        percentageChange:
            json["percentageChange"] == null
                ? undefined
                : json["percentageChange"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function AggregatedUptimeResponseToJSON(
    value?: AggregatedUptimeResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uptimeOfflineIncluded: value["uptimeOfflineIncluded"],
        uptimeOfflineExcluded: value["uptimeOfflineExcluded"],
        preferredUptime: value["preferredUptime"],
        isOfflineIncluded: value["isOfflineIncluded"],
        percentageChange: value["percentageChange"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
